var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF784E",
    d: "M67 134c-37.003 0-67-29.997-67-67S29.997 0 67 0s67 29.997 67 67c0 17.77-7.059 34.811-19.624 47.376C101.811 126.941 84.77 134 67 134z",
    transform: "translate(-653 -169) translate(504 122) translate(149 47)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.305.64H26.499c-2.589 0-4.695 2.106-4.695 4.694v27.732c0 2.588 2.106 4.695 4.695 4.695h40.806c2.589 0 4.695-2.107 4.695-4.695V5.334C72 2.746 69.894.64 67.305.64zM48.007 22.415c-.586.585-1.625.585-2.213 0L27.148 3.77h39.508L48.007 22.416zM38.15 19.2L24.934 32.417V5.983L38.15 19.2zm2.215 2.214l3.217 3.216c.915.916 2.116 1.374 3.319 1.374 1.202 0 2.405-.458 3.319-1.374l3.218-3.217L66.656 34.63H27.148l13.217-13.217zm15.287-2.216L68.869 5.982v26.434L55.652 19.198zM15.431 17.635H5.814c-.864 0-1.565.701-1.565 1.565s.7 1.565 1.565 1.565h9.616c.865 0 1.566-.701 1.567-1.565 0-.864-.701-1.565-1.566-1.565zM16.996 10.702c0-.865-.7-1.566-1.566-1.566H1.565C.7 9.136 0 9.836 0 10.702c0 .864.7 1.564 1.565 1.564H15.43c.865 0 1.566-.7 1.566-1.564zM15.43 26.132h-5.367c-.865 0-1.565.7-1.565 1.565s.7 1.565 1.565 1.565h5.367c.865 0 1.566-.7 1.566-1.565 0-.864-.7-1.565-1.566-1.565z",
    transform: "translate(-653 -169) translate(504 122) translate(149 47) rotate(-20 187.61 -44.905)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSuccess);
export default __webpack_public_path__ + "static/media/EmailSuccess.1d4e98d3.svg";
export { ForwardRef as ReactComponent };